exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back-office-search {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 13px;\n  line-height: 1.5;\n  border-radius: 0px;\n  padding: 0 5px;\n  font-family: Arial,Helvetica,sans-serif;\n  height: 26px;\n}\n", ""]);

// exports
